import HeaderContent from "component/layout/HeaderContent";
import React from "react";
import { useNavigate } from "react-router-dom";
import TopHeader from "../TimelinePage/component/TopHeader";
import AdviceTimelineGraphPage from "./AdviceTimelineGraphPage";
import { useLocation } from "react-router-dom";
import { toJS } from "mobx";

export default function TimelinePageRouter() {
  const location = useLocation();
  const employee = location.state.employee;

  const navigate = useNavigate();

  return (
    <HeaderContent>
      {/* <TopHeader  isChangeIcon onClickChangeIcon={onChangeToTimeline}/> */}

      {/* <AdviceTimelineGraphPage /> */}
    </HeaderContent>
  );
}
